import { type FormGroup } from '@angular/forms';

export function confirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
      return;
    }
    if (control && control.value !== matchingControl.value) {
      matchingControl.setErrors({
        confirmedValidator: true,
      });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
